export const menuItems = [
    {
        id: 1,
        label: "menuitems.menu.text",
        isTitle: true
    },
    {
        id: 2,
        label: "menuitems.dashboard.text",
        link: "/",
        icon: "bx-home-circle",
    },

    {
        id: 3,
        label: "menuitems.customers.text",
        link: "/customers",
        icon: "bx-user",
    },

    {
        id: 4,
        label: "menuitems.categories.text",
        link: "/categories",
        icon: "bx-grid-alt",
    },
    {
        id: 29,
        label: "menuitems.subcategories.text",
        link: "/subcategories",
        icon: "bx-grid-alt",
    },

    {
        id: 5,
        label: "menuitems.products.text",
        link: "/products",
        icon: "bx-package",
    },

    {
        id: 6,
        label: "menuitems.online-orders.text",
        link: "/online-orders",
        icon: "bx-cart",
    },

    {
        id: 31,
        label: "menuitems.store-orders.text",
        link: "/store-orders",
        icon: "bx-cart",
    },

    {
        id: 7,
        label: "menuitems.stores.text",
        link: "/stores",
        icon: "bx-store",
    },

    {
        id: 8,
        label: "menuitems.store-stock.text",
        link: "/store-stock",
        icon: "bx-box",
    },

    {
        id: 9,
        label: "menuitems.listing-category.text",
        link: "/listing-category",
        icon: "bx-list-ul",
    },

    {
        id: 10,
        label: "menuitems.cutting-types.text",
        link: "/cutting-types",
        icon: "bx-cut",
    },

    {
        id: 11,
        label: "menuitems.staffs.text",
        link: "/staffs",
        icon: "bx-user-pin",
    },
    {
        id: 30,
        label: "menuitems.delivery-boys.text",
        link: "/delivery-boys",
        icon: "bx-user-pin",
    },

    {
        id: 12,
        label: "menuitems.warehouse.text",
        link: "/warehouse",
        icon: "bx-home",
    },

    {
        id: 13,
        label: "menuitems.vouchers.text",
        link: "/vouchers",
        icon: "bxs-coupon",
    },

    {
        id: 14,
        label: "menuitems.notifications.text",
        link: "/notifications",
        icon: "bx-bell",
    },

    {
        id: 15,
        label: "menuitems.sliders.text",
        link: "/sliders",
        icon: "bx-slider-alt",
    },

    {
        id: 16,
        label: "menuitems.settings.text",
        link: "/settings",
        icon: "bx-cog",
    },

    {
        id: 17,
        label: "menuitems.reports.text",
        link: "",
        icon: "bx-file",
        
        subItems: [
            {
                id: 18,
                label: "menuitems.reports.list.sales",
                link: "/reports/sales",
                parentId: 17
            },
            {
                id: 19,
                label: "menuitems.reports.list.stock",
                link: "/reports/stock",
                parentId: 17
            },
            {
                id: 20,
                label: "menuitems.reports.list.voucher",
                link: "/reports/voucher",
                parentId: 17
            },
           
        ]
    },


    // {
    //     id: 21,
    //     label: "menuitems.enquiries.text",
    //     link: "/enquiries",
    //     icon: "bx-message-square-dots",
    // },

    {
        id: 22,
        label: "menuitems.cms.text",
        link: "",
        icon: "bx-mobile",
        
        subItems: [
            {
                id: 23,
                label: "menuitems.cms.list.about",
                link: "/cms/about",
                parentId: 22
            },
            {
                id: 24,
                label: "menuitems.cms.list.contact",
                link: "/cms/contact",
                parentId: 22
            },
            {
                id: 25,
                label: "menuitems.cms.list.privacy",
                link: "/cms/privacy-policy",
                parentId: 22
            },
            {
                id: 26,
                label: "menuitems.cms.list.terms",
                link: "/cms/terms-and-conditions",
                parentId: 22
            },
            {
                id: 27,
                label: "menuitems.cms.list.refund",
                link: "/cms/refund-policy",
                parentId: 22
            },
            {
                id: 28,
                label: "menuitems.cms.list.faq",
                link: "/cms/faq",
                parentId: 22
            },
            
        ]
    },

    

   

    

    // {
    //     id: 5,
    //     label: "menuitems.fuelstations.text",
    //     link: "/fuel-stations",
    //     icon: "bx-gas-pump",
    // },

    // {
    //     id: 15,
    //     label: "menuitems.fsfuels.text",
    //     link: "/fuel-station-fuels",
    //     icon: "bx-filter-alt",
    // },    
  

    // {
    //     id: 6,
    //     label: "menuitems.trucks.text",
    //     link: "",
    //     icon: "bxs-truck",

    //     subItems: [
    //         {
    //             id: 7,
    //             label: "menuitems.trucks.list.pending",
    //             link: "/pending-trucks",
    //             parentId: 6
    //         },
    //         {
    //             id: 8,
    //             label: "menuitems.trucks.list.approved",
    //             link: "/trucks",
    //             parentId: 6
    //         },
    //     ]
    // },
    

    // {
    //     id: 9,
    //     label: "menuitems.drivers.text",
    //     link: "",
    //     icon: "bx-user-circle",
        
    //     subItems: [
    //         {
    //             id: 10,
    //             label: "menuitems.drivers.list.pending",
    //             link: "/pending-drivers",
    //             parentId: 9
    //         },
    //         {
    //             id: 11,
    //             label: "menuitems.drivers.list.approved",
    //             link: "/drivers",
    //             parentId: 9
    //         },
           
    //     ]
    // },

    

    // {
    //     id: 17,
    //     label: "menuitems.reports.list.earnings",
    //     link: "/reports/earnings",
    //     icon: "bx-dollar-circle",
    // },

    
    // {
    //     id: 4,
    //     label: "menuitems.fuels.text",
    //     link: "/fuels",
    //     icon: "bx-droplet",
    // },
   

    

      

    // {
    //     id: 18,
    //     label: "menuitems.ratings.text",
    //     link: "",
    //     icon: "bx-star",
        
    //     subItems: [
    //         {
    //             id: 19,
    //             label: "menuitems.ratings.list.customers",
    //             link: "/ratings/customers",
    //             parentId: 18
    //         },
    //         {
    //             id: 20,
    //             label: "menuitems.ratings.list.drivers",
    //             link: "/ratings/drivers",
    //             parentId: 18
    //         },
           
    //     ]
    // },

    // {
    //     id: 21,
    //     label: "menuitems.subadmins.text",
    //     link: "/subadmins",
    //     icon: "bx-group",
    // },

    

   

    
];

